import { render, staticRenderFns } from "./AccountSettingBranches.vue?vue&type=template&id=f86b86bc&"
import script from "./AccountSettingBranches.vue?vue&type=script&lang=js&"
export * from "./AccountSettingBranches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports